import React from 'react';
import { connect } from 'react-redux';
import Login from '../Login/Login';
import { ReportFeedWidget } from '../ReportFeedPage/ReportFeedWidget';
import { LastReportWidget } from '../LastReportWidget/LastReportWidget';
import { LeaderboardWidget } from '../LeaderboardWidget/LeaderboardWidget';
import TournamentsPage from '../TournamentsPage';
import { Redirect } from 'react-router-dom';
export class StarPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = { data: {}, serverErrors: {} };


        console.info('StarPage - constructor called.');
    }

    componentWillMount() {
        console.info('StarPage - componentWillMount called.');
    }

    componentDidMount() {
        console.info('StarPage - componentDidMount called.');
    }

    componentWillReceiveProps(nextProps) {

    }

    shouldComponentUpdate() {
        return true;
    }

    componentWillUpdate() {
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
    }


    onChange(e) {

    }


    render() {
        console.info('Startage - render called.', this.props);
        let user = this.props.userData.user;

        if (user && user.token) {
            console.info('Startage TournamentsPage');
            return <Redirect to="/tournaments" />
        } else {
            return <Login />
        }
        // return (
        //     <div>
        //         <div style={{ float: 'left', width: 375 }}>
        //         <h2>All reports</h2>
        //             <ReportFeedWidget leaderboard={this.props.leaderboardData.leaderboard} />
        //         </div>
        //         <div style={{ float: 'left' }}>
        //             <LastReportWidget lastitem={this.props.leaderboardData.last} />
        //         </div>
        //         <div style={{ float: 'left' }}>
        //         <h2>Leaderboard</h2>
        //             <LeaderboardWidget  />
        //         </div>
        //     </div>
        // );
    }

}


/**
 * Get data from store
 * @param state
 */
const mapStateToProps = state => ({
    userData: state.userData,
    leaderboardData: state.leaderboard,

});

/**
 * Import action from dir action above - but must be passed to connect method in order to trigger reducer in store
 * @type {{UserUpdate: UserUpdateAction}}
 */
const mapActionsToProps = {

};

export default connect(mapStateToProps, mapActionsToProps)(StarPage);



// WEBPACK FOOTER //
// ./src/Components/StartPage/StartPage.js